import a from "./td-longtail-vue-components96.js";
/* empty css                             */
import s from "./td-longtail-vue-components98.js";
var l = function() {
  var e = this, n = e._self._c, t = e._self._setupProxy;
  return e.isExternal === void 0 && t.tagComponent !== "a" || e.isExternal === !1 ? n(t.tagComponent, e._b({ ref: "linkElement", tag: "component", class: t.classes, attrs: { "data-tealium-rel": t.dataTealium, disabled: e.disabled, type: e.type }, on: { click: t.onClick } }, "component", t.linkProps, !1), [e._t("default", function() {
    return [e._v(e._s(e.label))];
  })], 2) : n("a", { ref: "linkElement", class: t.classes, attrs: { href: t.link?.toString(), target: e.sameWindow ? "_self" : "_blank", "data-tealium-rel": t.dataTealium } }, [e._t("default", function() {
    return [e._v(e._s(e.label))];
  }), e.isExternal && !e.sameWindow ? n("span", { staticClass: "sr-only" }, [e._v("(Wird in einem neuen Tab geöffnet)")]) : e._e()], 2);
}, r = [], i = /* @__PURE__ */ s(
  a,
  l,
  r,
  !1,
  null,
  "2471f613"
);
const c = i.exports;
export {
  c as default
};
